import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  $getSelection,
  $isRangeSelection,
  type LexicalCommand,
} from 'lexical';
import { $createDynamicTagNode, type DynamicTagType } from './DynamicTagNode';

export interface InsertDynamicTagPayload {
  tagType: DynamicTagType;
  fieldIds?: string[];
  fieldContext?: string;
  value?: string;
  label: string;
}

export const INSERT_DYNAMIC_TAG_COMMAND: LexicalCommand<InsertDynamicTagPayload> =
  createCommand('INSERT_DYNAMIC_TAG_COMMAND');

export function DynamicTagPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand<InsertDynamicTagPayload>(
      INSERT_DYNAMIC_TAG_COMMAND,
      (payload) => {
        editor.update(() => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) {
            return;
          }

          const tagNode = $createDynamicTagNode({
            tagType: payload.tagType,
            fieldIds: payload.fieldIds,
            fieldContext: payload.fieldContext,
            value: payload.value,
            label: payload.label,
          });

          selection.insertNodes([tagNode]);
        });
        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
